import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { login } from '../utils/auth';
import '../styles/Auth.css';
import PasswordReset from './PasswordReset';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLock, faEye, faEyeSlash, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPasswordReset, setShowPasswordReset] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const navigate = useNavigate();

  // Validation states
  const [emailValid, setEmailValid] = useState(true);
  const [passwordValid, setPasswordValid] = useState(true);

  // Reset error when inputs change
  useEffect(() => {
    if (formSubmitted) {
      validateEmail(email);
      validatePassword(password);
    }
  }, [email, password, formSubmitted]);

  const validateEmail = (email) => {
    const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    setEmailValid(valid);
    return valid;
  };

  const validatePassword = (password) => {
    const valid = password.length > 0;
    setPasswordValid(valid);
    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    setError('');
    
    // Validate inputs
    const isEmailValid = validateEmail(email);
    const isPasswordValid = validatePassword(password);
    
    if (!isEmailValid || !isPasswordValid) {
      return;
    }
    
    setLoading(true);

    try {
      const res = await login(email, password);
      
      // Add a small delay to ensure token is set
      await new Promise(resolve => setTimeout(resolve, 100));
  
      // Then navigate based on role
      if (res.user.role === 'customer') {
        navigate('/customer');
      } else if (res.user.role === 'vendor') {
        navigate('/vendor/dashboard');
      } else if (res.user.role === 'admin') {
        navigate('/admin/dashboard');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please check your credentials and try again.');
    } finally {
      setLoading(false);
    }
  };

// if (showPasswordReset) {
//   return (
//     <PasswordReset
//       isModal={false}
//       isLoggedOut={true}
//       onClose={() => setShowPasswordReset(false)}
//       onSuccess={() => setShowPasswordReset(false)}
//     />
//   );
// }

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <button 
              className="back-button-auth" 
              onClick={() => navigate('/')}
              aria-label="Back to home"
            >
              <FontAwesomeIcon icon={faArrowLeft} />
            </button>
            <h1>Welcome Back</h1>
            <p>Log in to your account to continue</p>
          </div>

          {error && <div className="error-message">{error}</div>}
          
          <form onSubmit={handleSubmit} className="auth-form">
            <div className={`form-group ${!emailValid ? 'error' : ''}`}>
              <div className="input-icon-wrapper">
                <FontAwesomeIcon icon={faEnvelope} className="input-icon" />
                <input 
                  type="email" 
                  placeholder="Email Address" 
                  value={email} 
                  onChange={(e) => setEmail(e.target.value)} 
                  required
                  disabled={loading}
                  className={!emailValid ? 'invalid' : ''}
                />
              </div>
              {!emailValid && <p className="validation-message">Please enter a valid email address</p>}
            </div>
            
            <div className={`form-group ${!passwordValid ? 'error' : ''}`}>
              <div className="input-icon-wrapper">
                <FontAwesomeIcon icon={faLock} className="input-icon" />
                <input 
                  type={showPassword ? "text" : "password"}
                  placeholder="Password" 
                  value={password} 
                  onChange={(e) => setPassword(e.target.value)} 
                  required
                  disabled={loading}
                  className={!passwordValid ? 'invalid' : ''}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="password-toggle"
                  disabled={loading}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                </button>
              </div>
              {!passwordValid && <p className="validation-message">Password is required</p>}
            </div>
            
         <div className="forgot-password">
          <button 
            type="button"
            onClick={() => {
              console.log("Setting showPasswordReset to true");
              setShowPasswordReset(true);
            }}
            className="forgot-password-link"
            disabled={loading}
          >
            Forgot Password?
          </button>
        </div>
            
            <button 
              type="submit" 
              className="auth-button"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner"></span>
                  Logging in...
                </>
              ) : 'Log In'}
            </button>
          </form>
          
          <div className="auth-footer">
            <p>Don't have an account?</p>
            {/* <Link to="/register" className="auth-link">Create Account</Link> */}
          </div>
          
          <div className="auth-separator">
            <span>Create account as a</span>
          </div>
          
          <div className="auth-options">
            <Link to="/vendor/register" className="option-button vendor">
              Business Owner
            </Link>
          </div>
           {showPasswordReset && (
          <PasswordReset
            isModal={true}
            isLoggedOut={true}
            isAuthPage={true} // Add this new prop
            onClose={() => setShowPasswordReset(false)}
            onSuccess={() => setShowPasswordReset(false)}
          />
        )}
        </div>
      </div>
    </div>
  );
}

export default Login;